import { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";

// Casino game iframe (Saba / Aviator / Bet By Provider / etc).
const CasinoIframeModal = ({ url, onClose }) => {
    const [loading, setLoading] = useState(true);

    if (!url) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                width: "100%",
                height: "100%",
                zIndex: 999999999,
                backgroundColor: "#1b2336",
            }}
        >
            <iframe
                key={url}
                src={url}
                title="Casino Game"
                onLoad={() => setLoading(false)}
                allow="autoplay; fullscreen; payment"
                allowFullScreen
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    display: "block",
                }}
            />

            {loading && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        pointerEvents: "none",
                        background: "#1b2336",
                    }}
                >
                    <div style={{ fontSize: 14, opacity: 0.85 }}>Loading game…</div>
                </div>
            )}

            <button
                onClick={onClose}
                title="Back"
                style={{
                    position: "absolute",
                    top: 12,
                    left: 12,
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    border: "none",
                    background: "rgba(0,0,0,0.55)",
                    color: "#fff",
                    fontSize: 16,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 2,
                }}
            >
                <FaArrowLeft />
            </button>
        </div>
    );
};

export default CasinoIframeModal;
